export default __webpack_public_path__ + "static/media/6.f2301de9.png";